import { APP_FEATURES } from '@/lib/app/features';
import Constants from 'expo-constants';
import * as React from 'react';

function parseVersion(value: string) {
  return value
    .split('.')
    .map((segment) => Number.parseInt(segment, 10))
    .map((segment) => (Number.isFinite(segment) ? segment : 0));
}

export function isVersionAtLeast(version: string, minimum: string) {
  const current = parseVersion(version);
  const target = parseVersion(minimum);
  const length = Math.max(current.length, target.length);

  for (let index = 0; index < length; index += 1) {
    const currentSegment = current[index] ?? 0;
    const targetSegment = target[index] ?? 0;

    if (currentSegment > targetSegment) {
      return true;
    }
    if (currentSegment < targetSegment) {
      return false;
    }
  }

  return true;
}

export function useWorkspaceCapability() {
  const currentVersion = Constants.nativeAppVersion ?? Constants.expoConfig?.version ?? '0.0.0';
  const minimumVersion = APP_FEATURES.orgWorkspaceMinVersion;

  const supportsOrgWorkspace = React.useMemo(
    () => isVersionAtLeast(currentVersion, minimumVersion),
    [currentVersion, minimumVersion]
  );

  return {
    currentVersion,
    minimumVersion,
    supportsOrgWorkspace,
  };
}
